import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../Common/ScrollReveal";
import HeroSection from "./HeroSection";
import WelcomeSection from "./WelcomeSection";
import FinancialSolutions from "./FinancialSolutions";
import ImageSection from "./ImageSection";
import WhyChooseUsNew from "./WhyChooseUsNew";
import "./Landing.css";
import BestServices from "./BestServices";
import Testimonials from "./Testimonials";
import ImageSection2 from "./ImageSection2";
import CustomerReviews from "./CustomerReviews";
import ContactUsSection from "./ContactUsSection";

const Landing = () => {
  return (
    <div className="w-full max-w-screen overflow-x-hidden bg-white">
      
      {/* Hero Section */}
      <HeroSection />

      {/* Welcome Section */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <WelcomeSection />
      </ScrollReveal>

      {/* Financial Solutions Section */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <FinancialSolutions />
      </ScrollReveal>

      {/* Image Section */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <ImageSection />
      </ScrollReveal>

      {/* Why Choose Us New Section */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <WhyChooseUsNew />
      </ScrollReveal>

      {/* Loan Calculator CTA Section */}
      <ScrollReveal variant="fadeUp">
        <section 
          className="loan-calculator-cta-section"
          style={{
            backgroundImage: 'url(/bg2.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
        <div className="loan-calculator-cta-container">
          <div className="loan-calculator-cta-content">
            <h2 className="loan-calculator-cta-title">Use Our Loan Calculator</h2>
            <p className="loan-calculator-cta-description">
              Plan your finances with confidence. Our easy-to-use loan calculator helps you estimate your EMI, total interest, and repayment schedule in seconds.
            </p>
            <Link to="/loan-calculator" className="loan-calculator-cta-btn">
              Open Loan Calculator
            </Link>
          </div>
        </div>
      </section>
      </ScrollReveal>

      {/* Best Services Section */}
      <ScrollReveal variant="fadeUp" delay={0.1}>
        <BestServices />
      </ScrollReveal>

      {/* Testimonials Section */}
      <ScrollReveal variant="fadeUp">
        <Testimonials />
      </ScrollReveal>

      {/* Image Section 2 */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <ImageSection2 />
      </ScrollReveal>

      {/* Customer Reviews Section */}
      <ScrollReveal variant="fadeUp" amount={0.2}>
        <CustomerReviews />
      </ScrollReveal>

      {/* Contact Us Section */}
      {/* <ScrollReveal variant="fadeUp" amount={0.2}>
        <ContactUsSection />
      </ScrollReveal> */}

      {/* Ready & Get Started CTA Section */}
      {/* <ScrollReveal variant="fadeUp">
        <section className="ready-getstarted-section">
        <div className="ready-getstarted-container">
          <div className="ready-getstarted-content">
            <h2 className="ready-getstarted-title">Ready to Get Started?</h2>
            <p className="ready-getstarted-description">
              Join thousands of satisfied customers. Begin your journey with Pawansut today and take the first step towards your financial goals.
            </p>
            <Link to="/contact" className="ready-getstarted-btn">
              Get Started
            </Link>
          </div>
        </div>
      </section>
      </ScrollReveal> */}
    </div>
  );
};

export default Landing;

